export const ERR_ACCOUNT_REMOVED =
    'Your account has been deleted and you cannot sign in. Please contact support if you believe this is an error.';

export const ERR_TRY_RELOADING =
    'Please try reloading this page in a few moments';

export const ERR_AUTH_PROCESS =
    'Something went wrong in the authentication process';

export const ERR_AUTH_TIMED_OUT = 'Authentication timed out';

export const ERR_USER_CREATE =
    'Something went wrong when we were creating your user account. You can try again in a few moments';

export const MSG_ACCOUNT_ALREADY_EXISTS = 'You have set up your account already. Navigate to the Settings page if you wish to cancel it.';

export const ERR_UNKNOWN = 'An error occurred';

/** Maps UserGet (/user/get) HTTP status to a user-facing message.
 *  The handler returns 403 only when the account is soft-deleted (isRemoved), and 401 when the
 *  Firebase id token is invalid, expired, or does not match the claimed user id. */
export function userGetErrorMessage(status: number): string {
  switch (status) {
    case 403:
      return ERR_ACCOUNT_REMOVED;
    default:
      // A reload makes Firebase mint a fresh token, which is what an expired one needs.
      return ERR_TRY_RELOADING;
  }
}
